export default __webpack_public_path__ + "static/Inter-Bold-900093fd81dfbbf8a38db24d2af7510f.woff2";